export function getCreateEventFormTitle(createEventCallForServicePrefillOptionLabel?: string) {
    return createEventCallForServicePrefillOptionLabel
        ? `New ${createEventCallForServicePrefillOptionLabel}`
        : 'New Event';
}
